import { getInternalLinkForPath } from '..'
import { DOMAIN_NAME } from '../../../../constants/pages'

export const getUrlForPath = (path = '') => (
    `${DOMAIN_NAME}${getInternalLinkForPath(path)}`
)
